import React from 'react';

import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { DocumentMappedStatus } from '@app/models/wms';

const STATUS_COLOR: Record<DocumentMappedStatus, string> = {
  [DocumentMappedStatus.Planned]: 'blue',
  [DocumentMappedStatus.Picking]: 'orange',
  [DocumentMappedStatus.Assembled]: 'gold',
  [DocumentMappedStatus.Shipped]: 'green',
  [DocumentMappedStatus.Cancelled]: 'red',
};

interface IProps {
  status?: DocumentMappedStatus | null;
  rawStatus?: string | null;
}

export const MappedStatusTag: React.FC<IProps> = ({ status, rawStatus }) => {
  const documentsT = useTranslation(NSKeys.warehouseDocuments);

  if (status) {
    return <Tag color={STATUS_COLOR[status]}>{documentsT.t(`status.${status}`)}</Tag>;
  }

  if (rawStatus) {
    return <Tag>{rawStatus}</Tag>;
  }

  return <span>—</span>;
};
